import React from 'react';

const SelectorProductoPlaca = () => {
  return (
    <section className="bg-light">
      <div className="container">
        <div className="row justify-content-center mb-2-9">
          <div className="col-lg-10 text-center">
            <div className="title-style2 mb-1-9 wow fadeIn" data-wow-delay="100ms">
              <h2 className="h1">Elige el tipo de instalación que se adapte a tu proyecto</h2>
            </div>
            <p className="mb-0 text-secondary">
              
            </p>
          </div>
        </div>
        
        <div className="row mt-n1-9 justify-content-center">
          <div className="col-lg-5 col-md-6 mt-1-9">
            <div className="card border-0 h-100 wow fadeIn" data-wow-delay="200ms">
              <div className="card-body p-1-9 p-lg-2-3">
                <div className="mb-1-6 position-relative">
                  <span className="badge bg-primary text-white position-absolute top-0 end-0 m-3 px-3 py-2">
                     NUEVO PRODUCTO
                  </span>
                  <div style={{ height: '200px', overflow: 'hidden' }} className="rounded">
                    <img 
                      src={`${process.env.PUBLIC_URL}/assets/img/productos/muro-placa-tipo-marmol/rollo-marmol/rollo-pvc-4.jpeg`}
                      alt="Placas en Rollo Autoadhesivas" 
                      className="w-100"
                      style={{ objectFit: 'cover', height: '100%' }}
                    />
                  </div>
                </div>
                <h3 className="h4 mb-1-6">Placas en Rollo Autoadhesivas</h3>
                <p className="mb-1-6 font-weight-600 text-primary">
                  Instalación instantánea sin obra.
                </p>
                <p className="mb-1-6">
                  Sistema autoadherible que se fija en minutos sin herramientas ni instaladores. 
                  Ideal para proyectos DIY, espacios de renta y quienes buscan renovar sin complicaciones.
                </p>
                
                <ul className="list-style1 mb-1-9">
                  <li className="mb-2">Sin instaladores profesionales</li>
                  <li className="mb-2">Rollos de 2.77m x 1.20m</li>
                  <li className="mb-0">Flexible y reposicionable</li>
                </ul>
                
                <a href="#rollo-autoadhesivo" className="butn-style7 w-100 text-center">
                  <span>Ver Placas en Rollo</span>
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-5 col-md-6 mt-1-9">
            <div className="card border-0 h-100 wow fadeIn" data-wow-delay="400ms">
              <div className="card-body p-1-9 p-lg-2-3">
                <div className="mb-1-6">
                  <div style={{ height: '200px', overflow: 'hidden' }} className="rounded">
                    <img 
                      src={`${process.env.PUBLIC_URL}/assets/img/productos/muro-placa-tipo-marmol/placa-tipo-marmol-intro-der.jpg`}
                      alt="Placas Tradicionales PVC" 
                      className="w-100"
                      style={{ objectFit: 'cover', height: '100%' }}
                    />
                  </div>
                </div>
                <h3 className="h4 mb-1-6">Placas Rígidas PVC</h3>
                <p className="mb-1-6 font-weight-600 text-primary">
                  Instalación profesional con perfiles.
                </p>
                <p className="mb-1-6">
                  Sistema de montaje con perfiles de aluminio para acabados permanentes y duraderos. 
                  Mayor resistencia a impactos y desgaste. Ideal para proyectos comerciales y residenciales.
                </p>
                
                <ul className="list-style1 mb-1-9">
                  <li className="mb-2">Instalación con perfiles de aluminio</li>
                  <li className="mb-2">Acabado profesional permanente</li>
                  <li className="mb-0">4 modelos exclusivos</li>
                </ul>
                
                <a href="#placas-tradicionales" className="butn-style7 w-100 text-center">
                  <span>Ver Placas Rígidas</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-2-9">
          <div className="col-12 text-center">
            <p className="mb-1-6">
              ¿No sabes cuál elegir? Nuestros asesores comerciales te ayudan a seleccionar la mejor opción.
            </p>
            <a href="#contacto" className="butn-style7">
              <span>Contáctanos</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SelectorProductoPlaca;